var _defs, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseFullpagePopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f0f0;}.cls-2{fill:#737373;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close-fullpage-popup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1014.1-24.6A1.5,1.5,0,0,1,1013-25a1.5,1.5,0,0,1,0-2.12l19.8-19.8a1.5,1.5,0,0,1,2.12,0,1.5,1.5,0,0,1,0,2.12L1015.16-25A1.5,1.5,0,0,1,1014.1-24.6Z",
    transform: "translate(-1004 56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1033.9-24.6a1.5,1.5,0,0,1-1.06-.44L1013-44.84a1.5,1.5,0,0,1,0-2.12,1.5,1.5,0,0,1,2.12,0l19.8,19.8a1.5,1.5,0,0,1,0,2.12A1.5,1.5,0,0,1,1033.9-24.6Z",
    transform: "translate(-1004 56)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFullpagePopup);
export default __webpack_public_path__ + "static/media/close-fullpage-popup.674de5025fc09be2ac2ceaca956fd031.svg";
export { ForwardRef as ReactComponent };